import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home";
import "./styles/main.scss";
import "./styles/icon.min.css";
import "bootstrap/dist/js/bootstrap.js";
import BlogDetails from "./pages/BlogDetails";
import Error from "./pages/Error";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from "./components/ScrollToTop";
import Portfolio from "./pages/Portfolio";
import { ReactLenis } from "lenis/react";

function App() {
  return (
    <ThemeProvider>
      <ReactLenis
        root
        options={{ lerp: 0.1, duration: 1.5, smoothWheel: true }}
      >
        <Router>
          <ScrollToTop />
          {/* <Navbar /> Navbar will be displayed on all pages */}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog/:slug" element={<BlogDetails />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/portfolio" element={<Portfolio />} />

              <Route path="*" element={<Error />} />
            </Routes>
          </main>
        </Router>
      </ReactLenis>
    </ThemeProvider>
  );
}

export default App;
